import React from 'react';
import { Formik, Form } from 'formik';
import { map } from 'lodash';

import { recipeOptions } from '../api/dummyData';
import { getInitialIngredients } from '../utilities/content/getInitialIngredients';
import { labels } from '../configuration/labels';

const RecipeSelect = ({ setSelectedRecipe, onRecipeChange }) => {
  function handleRecipeChange(e) {
    setSelectedRecipe(e.target.value);
    onRecipeChange(getInitialIngredients(e.target.value));
  }

  return (
    <div className="recipe-select">
      <h3>{labels.recipeSelectHeader}</h3>
      <Formik>
        <Form>
          <select onChange={handleRecipeChange} placeholder="Select one">
            <option value="">{labels.recipeSelectDefaultOption}</option>
            {map(recipeOptions, (recipeOption) => (
              <option key={recipeOption} value={recipeOption}>
                {recipeOption}
              </option>
            ))}
          </select>
        </Form>
      </Formik>
    </div>
  );
};

export default RecipeSelect;
